var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A4A",
    d: "M300 150c0 82.842-67.158 150-150 150S0 232.842 0 150 67.158 0 150 0s150 67.158 150 150"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M153.264 88.044a16.305 16.305 0 1 0 0 32.61 16.305 16.305 0 0 0 0-32.61m-52.176 0a16.305 16.305 0 1 0 0 32.61 16.305 16.305 0 0 0 0-32.61m104.352 0a16.308 16.308 0 1 0 0 32.61 16.308 16.308 0 0 0 0-32.61m-52.176 52.176a16.308 16.308 0 1 0 0 32.61 16.308 16.308 0 0 0 0-32.61m0 52.17a16.308 16.308 0 1 0 0 32.616 16.308 16.308 0 0 0 0-32.616"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStory);
export default __webpack_public_path__ + "static/media/story.8023bb22659e3c0ef7d71e34e9e0488a.svg";
export { ForwardRef as ReactComponent };